module.exports = __webpack_public_path__ + "static/media/slider_3_en_sm.a62d569c.svg";